import * as React from "react"
import { Skeleton } from "@mui/material"

import {WEBBACK_V2_API} from "@constants";
import { TitleWithPopover, AppTableSeeker } from "@components"
import {useToast} from "@hooks";
import { isLoadingCommonFilters } from "@signals"
import {useMarketplacesOffersDetailsFilters} from "../hooks";
import { imageSkuColumn, priceColumn, skuColumn, retailerColumn, sellerColumn, countriesColumn, countriesMatchColumn} from "./columns"

export default function MarketplacesOffersDetailsTable() {
    const { showToast } = useToast()
    const { tableData } = useMarketplacesOffersDetailsFilters()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!tableData?.length) return <></>

    return <AppTableSeeker
        title={<TitleWithPopover title="Marketplaces - Offers Details" />}
        data={tableData}
        columns={[
            ...retailerColumn(),
            imageSkuColumn(),
            skuColumn(),
            sellerColumn(),
            ...countriesColumn(),
            ...countriesMatchColumn(),
            priceColumn('actualPrice', 'Actual\nPrice', true),
            priceColumn('shippingPrice', 'Shipping\nPrice'),
        ]}
        options={{
            onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/marketplaces/offers-details/excel`)
        }}
    />
}